import { render, staticRenderFns } from "./ManageGuidanceWorkItemPage.vue?vue&type=template&id=2a7178e2&scoped=true&"
import script from "./ManageGuidanceWorkItemPage.vue?vue&type=script&lang=js&"
export * from "./ManageGuidanceWorkItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageGuidanceWorkItemPage.vue?vue&type=style&index=0&id=2a7178e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7178e2",
  null
  
)

export default component.exports